export const doors = [
    {lvl: 1, name: 'Standard', armour: 8, hull: 80, firewalls: 1, firewallStrength : 5.6, hoursPerFW: 2},
    {lvl: 2, name: 'Reinforced', armour: 12, hull: 160, firewalls: 2, firewallStrength : 10.7, hoursPerFW: 2},
    {lvl: 3, name: 'Blast', armour: 16, hull: 320, firewalls: 3, firewallStrength : 16.8, hoursPerFW: 2},
];


export const shipHacks = [
    {class: 'Super Capitals', firewalls: 5, firewallStrength: 150.8, strengthMultiplier: 1, hoursPerFW: 8},
    {class: 'Capital Ships', firewalls: 3, firewallStrength: 75.6, strengthMultiplier: 1, hoursPerFW: 6},
    {class: 'Frigates', firewalls: 2, firewallStrength: 33.7, strengthMultiplier: 1, hoursPerFW: 4},
    {class: 'Corvettes', firewalls: 2, firewallStrength: 21.6, strengthMultiplier: 1, hoursPerFW: 1.5},
    {class: 'Heavy Freighters', firewalls: 2, firewallStrength: 16.8, strengthMultiplier: 1, hoursPerFW: 1},
    {class: 'Light Freighters', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 1},
    {class: 'Gunboats', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 1},
    {class: 'Bombers', firewalls: 1, firewallStrength: 5.6, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Fighters', firewalls: 1, firewallStrength: 5.6, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Satellites', firewalls: 1, firewallStrength: 2.6, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Cargo Containers', firewalls: 1, firewallStrength: 2.6, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Ground Vehicles', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Speeders', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Barges', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 0.5},
    {class: 'Boats and Submarines', firewalls: 1, firewallStrength: 8.9, strengthMultiplier: 1, hoursPerFW: 0.5},
]


